/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";

function load(path) {
  return function () {
    return import("@/pages/".concat(path, ".vue"));
  };
}

var routes = [{
  path: '/login',
  name: 'login',
  meta: {
    title: '哈啰换电'
  },
  component: load('login/index')
}, {
  path: '/rentLogin',
  name: 'rentLogin',
  meta: {
    title: '租车用户管理'
  },
  component: load('rentLogin/index')
}, {
  path: '/rentList',
  name: 'rentList',
  meta: {
    title: '租车用户管理'
  },
  component: load('rentList/index')
}, {
  path: '/rentForm',
  name: 'rentForm',
  meta: {
    title: '添加租车记录'
  },
  component: load('rentForm/index')
}, {
  path: '/share',
  name: 'share',
  meta: {
    title: '我的推广'
  },
  component: load('share/index')
}, {
  path: '/activity',
  name: 'activity',
  meta: {
    title: '活动'
  },
  component: load('activity/index')
}, {
  path: '/record',
  name: 'record',
  meta: {
    title: '我的绩效'
  },
  component: load('record/index')
}, {
  path: '/record/sub',
  name: 'recordSub',
  meta: {
    title: '我的绩效'
  },
  component: load('record/sub/index')
}, {
  path: '/power/marketing/index',
  name: 'marketing',
  meta: {
    title: '哈啰换电'
  },
  component: load('power/marketing/index')
}, {
  path: '*',
  redirect: '/login'
}];
export default routes;